import React, { useMemo } from "react";
import GlobalMetricCards from "../../../../global/GlobalMetricCards";
import {
  formatTrackingAmount,
  formatTrackingDate,
} from "../../utils/donationTrackingFormatters";

export default function DonationTrackingSummarySection({
  loading,
  summary,
  equipmentSummary,
}) {
  const items = useMemo(() => {
    const s = summary || {};
    const e = equipmentSummary || {};
    return [
      {
        key: "total_donations",
        label: "Total donations",
        value: s.total_donations ?? 0,
        tone: "slate",
        chartHeights: [0.45, 0.55, 0.5, 0.65, 0.6],
      },
      {
        key: "pending_donations",
        label: "Pending verification",
        value: s.pending_donations ?? 0,
        tone: "coral",
        chartHeights: [0.7, 0.5, 0.6, 0.45, 0.55],
      },
      {
        key: "approved_donations",
        label: "Approved",
        value: s.approved_donations ?? 0,
        tone: "mint",
        chartHeights: [0.4, 0.55, 0.7, 0.8, 0.75],
      },
      {
        key: "pending_amount",
        label: "Pending amount",
        value: formatTrackingAmount(s.pending_amount),
        tone: "teal",
        chartHeights: [0.55, 0.45, 0.5, 0.6, 0.5],
      },
      {
        key: "approved_amount",
        label: "Approved amount",
        value: formatTrackingAmount(s.approved_amount),
        tone: "mint",
        chartHeights: [0.5, 0.65, 0.75, 0.85, 0.9],
      },
      {
        key: "equipment",
        label: "Equipment gifts",
        value: e.total_equipment ?? 0,
        tone: "slate",
        chartHeights: [0.35, 0.5, 0.45, 0.55, 0.48],
      },
    ];
  }, [summary, equipmentSummary]);

  return (
    <section className="ddt-summary" aria-label="Donation tracking summary">
      <GlobalMetricCards
        loading={loading}
        ariaLabel="Donation tracking metrics"
        skeletonCount={6}
        items={items}
      />
      {!loading && summary?.last_donation_date ? (
        <p className="ddt-page__hint" style={{ marginTop: "0.65rem" }}>
          Last donation recorded on{" "}
          <strong>{formatTrackingDate(summary.last_donation_date)}</strong>.
        </p>
      ) : null}
    </section>
  );
}
